<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="jamKerja && jamKerja.konfigurasi_jadwal_id ? 'Ubah Jam Kerja Khusus' : 'Tambah Jam Kerja Khusus'"
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="9" lg="9" xl="9">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption mb-2">Nama Jadwal</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  name="nama"
                  label="Label Jam kerja"
                  v-model="jamKerja.nama"
                  hint="Masukkan Label Jam kerja"
                  data-vv-name="nama"
                  data-vv-as="Nama"
                  v-validate="'required'"
                  rows="2"
                  :error-messages="errors.collect('form.nama')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption mb-2">Tipe Jam Kerja</label>
                <v-select
                  :disabled="jamKerja.k_tipe_jadwal == 1"
                  dense
                  single-line
                  outlined
                  :items="tipeJadwals"
                  name="TipeJadwal"
                  label="Tipe Jam Kerja"
                  v-model="jamKerja.k_tipe_jadwal"
                  hint="Tipe Jam Kerja"
                  type="number"
                  data-vv-name="k_tipe_jadwal"
                  data-vv-as="Tipe jamKerja"
                  v-validate="'required'"
                  item-text="keterangan"
                  item-value="k_tipe_jadwal"
                  item-disabled="disabled"
                  :error-messages="errors.collect('form.k_tipe_jadwal')"
                  @change="onChangeTipe"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption mb-2">Awal Berlaku</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Awal Berlaku"
                  v-model="jamKerja.tgl_berlaku"
                  :value="jamKerja.tgl_berlaku"
                  hint="Awal Berlaku"
                  data-vv-name="tgl_berlaku"
                  data-vv-as="Awal Berlaku"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.tgl_berlaku')"
                ></m-datepicker>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption mb-2">Akhir Berlaku</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Akhir Berlaku"
                  v-model="jamKerja.tgl_berakhir"
                  :value="jamKerja.tgl_berakhir"
                  :min="jamKerja.tgl_berlaku"
                  hint="Akhir Berlaku"
                  data-vv-name="tgl_berakhir"
                  data-vv-as="Akhir Berlaku"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.tgl_berakhir')"
                ></m-datepicker>
              </v-col>
            </v-row>
            <label class="caption mb-2">Keterangan</label>
            <v-textarea
              dense
              single-line
              outlined
              label="Deskripsi"
              v-model="jamKerja.keterangan"
              persistent-hint
              hint="Informasi yang Mendeskripsikan tentang Jam Kerja yang Dibuat"
              data-vv-name="keterangan"
              data-vv-as="Keterangan"
              rows="2"
              :error-messages="errors.collect('form.keterangan')"
            ></v-textarea>
            <v-alert color="warning" colored-border border="left" dense style="background-color: #fff1dc">
              <v-toolbar flat style="background-color: #fff1dc">
                <v-toolbar-title class="body-2">
                  Pilih Jumlah presensi yang akan diterapkan pada jadwal
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-select
                  v-model="jamKerja.k_jenis_presensi"
                  class="mt-5"
                  color="warning"
                  :items="presensis"
                  item-value="key"
                  item-text="value"
                  outlined
                  dense
                  style="width: 150px; border-color: coral"
                  data-vv-name="jenis_presensi"
                  data-vv-as="Jenis Presensi"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.jenis_presensi')"
                  @change="onChangePresensi"
                ></v-select>
              </v-toolbar>
            </v-alert>
          </v-form>
          <v-col
            v-if="jadwalKerja.length && jamKerja.k_jenis_presensi"
            cols="12"
            sm="12"
            md="12"
            lg="12"
            xl="12"
            class="pa-0 mt-5"
          >
            <div v-for="(jadwal, j) in jadwalKerja" :key="j">
              <v-alert dense class="mt-3" style="background-color: #d7d1ff">
                <v-toolbar flat style="background-color: #d7d1ff">
                  <v-toolbar-title class="body-2">
                    Pilih Hari yang akan di detailkan jam kerjanya
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-select
                    v-model="jadwal.hari"
                    class="mt-5"
                    :items="hari(jadwal)"
                    item-value="text"
                    item-text="text"
                    item-disabled="disabled"
                    multiple
                    outlined
                    dense
                    style="width: 150px"
                  >
                    <template v-slot:append-outer>
                      <v-btn color="red" depressed small icon style="background-color: red" @click="onDeleteJadwal(j)">
                        <v-icon color="white">mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-select>
                </v-toolbar>
              </v-alert>
              <v-stepper v-if="masterStepper.length" v-model="jadwal.stepper">
                <v-card class="d-flex justify-space-between mb-6 py-2" tile>
                  <v-card v-for="(index, i) in masterStepper" :key="i" class="pa-2 mx-4" flat>
                    <v-list-item class="px-0 text-center">
                      <v-list-item-avatar :color="jadwal.stepper < index ? 'grey' : 'primary'" size="30">
                        <template v-if="jadwal.stepper === index">
                          <v-icon dark>mdi-pencil</v-icon>
                        </template>
                        <template v-else-if="jadwal.stepper <= index">
                          <span class="white--text">{{ i + 1 }}</span>
                        </template>
                        <template v-else>
                          <v-icon dark>mdi-check</v-icon>
                        </template>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-2 text-left">
                        <div>{{ steppers[index] || 'Jam Presensi' }}</div>
                        <template v-if="![null, undefined, ''].includes(jadwal.valid[index])">
                          <span :class="`${jadwal.valid[index] ? 'success--text' : 'red--text'}`">
                            {{ jadwal.valid[index] ? 'Data Lengkap' : 'Data Belum Lengkap' }}
                          </span>
                        </template>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-card>
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <div class="primary--text">
                      <b class="body-1 font-weight-bold">Detail Jam Masuk Kerja</b> (Lengkapi semua data berikut)
                    </div>
                    <v-form @submit.prevent :data-vv-scope="`form-datang-${j}`" lazy-validation>
                      <v-row dense class="mt-2">
                        <template v-if="jamKerja.k_jenis_presensi === 1">
                          <v-col cols="12" sm="12" md="6">
                            <label class="caption mb-2">Jam Masuk</label>
                            <m-timepicker
                              v-model="jadwal.detail_jam_kerja.jam_datang"
                              outlined
                              dense
                              :data-vv-name="`jam_datang`"
                              data-vv-as="Jam Datang"
                              v-validate="'required'"
                              :error="errors.collect(`form-datang-${j}.jam_datang`)"
                            >
                            </m-timepicker>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <label class="caption mb-2">Batas Akhir</label>
                            <m-timepicker
                              v-model="jadwal.detail_jam_kerja.batas_jam_datang_akhir"
                              outlined
                              dense
                              :data-vv-name="`batas_datang_selesai`"
                              data-vv-as="Batas Jam Datang Selesai"
                              v-validate="'required'"
                              :error="errors.collect(`form-datang-${j}.batas_datang_selesai`)"
                            >
                            </m-timepicker>
                          </v-col>
                        </template>
                        <template v-else>
                          <v-col cols="12" sm="12" md="12">
                            <template v-if="jamKerja.k_jenis_presensi !== 1">
                              <v-alert v-if="checkToleransi(jadwal.detail_jam_kerja)" type="error" text>
                                Terdeteksi jam kerja yang masih ada irisan/bertabrakan. Cek kembali jam kerja,
                                toleransi, batas awal dan batas akhir
                              </v-alert>
                            </template>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <label class="caption mb-2">Jam Masuk Kerja</label>
                            <m-timepicker
                              v-model="jadwal.detail_jam_kerja.jam_datang"
                              outlined
                              dense
                              :data-vv-name="`jam_datang`"
                              data-vv-as="Jam Datang"
                              v-validate="'required'"
                              :error="errors.collect(`form-datang-${j}.jam_datang`)"
                            >
                            </m-timepicker>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <label class="caption mb-2">Toleransi Keterlambatan Masuk(Menit)</label>
                            <v-text-field
                              dense
                              single-line
                              outlined
                              label="Toleransi Masuk (Menit)"
                              hint="Toleransi Masuk"
                              type="number"
                              v-model="jadwal.detail_jam_kerja.toleransi_datang"
                              :data-vv-name="`toleransi_datang`"
                              data-vv-as="toleransi datang"
                              v-validate="'required'"
                              :error-messages="errors.collect(`form-datang-${j}.toleransi_datang`)"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <label class="caption mb-2 t">Batas Awal (Boleh Absensi Masuk)</label>
                            <m-timepicker
                              v-model="jadwal.detail_jam_kerja.batas_jam_datang_mulai"
                              :max="jadwal.detail_jam_kerja.jam_datang"
                              outlined
                              dense
                              :data-vv-name="`batas_datang_mulai`"
                              data-vv-as="Batas Jam Datang Mulai"
                              v-validate="'required'"
                              :error="errors.collect(`form-datang-${j}.batas_datang_mulai`)"
                            >
                            </m-timepicker>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <label class="caption mb-2">Batas Akhir (Boleh Absensi Masuk)</label>
                            <m-timepicker
                              v-model="jadwal.detail_jam_kerja.batas_jam_datang_akhir"
                              :min="jadwal.detail_jam_kerja.jam_datang"
                              outlined
                              dense
                              :data-vv-name="`batas_datang_selesai`"
                              data-vv-as="Batas Jam Datang Selesai"
                              v-validate="'required'"
                              :error="errors.collect(`form-datang-${j}.batas_datang_selesai`)"
                            >
                            </m-timepicker>
                          </v-col>
                        </template>
                      </v-row>
                    </v-form>

                    <v-btn
                      v-if="jamKerja.k_jenis_presensi !== 1"
                      color="primary"
                      small
                      depressed
                      @click="onNext(`form-datang-${j}`, j)"
                    >
                      Selanjutnya<v-icon right>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <div class="primary--text">
                      <b class="body-1 font-weight-bold">Detail Istirahat</b> (Lengkapi semua data berikut)
                      <v-form @submit.prevent :data-vv-scope="`form-istirahat-${j}`" lazy-validation>
                        <v-row dense class="mt-2">
                          <v-col cols="12" sm="12" md="6">
                            <label class="caption mb-2">Mulai Istirahat</label>
                            <m-timepicker
                              v-model="jadwal.detail_jam_kerja.jam_istirahat_mulai"
                              :min="jadwal.detail_jam_kerja.batas_jam_datang_akhir"
                              :max="jadwal.detail_jam_kerja.jam_istirahat_selesai"
                              outlined
                              dense
                              :data-vv-name="`jam_istirahat_mulai`"
                              data-vv-as="Jam Mulai Istirahat"
                              v-validate="'required'"
                              :error="errors.collect(`form-istirahat-${j}.jam_istirahat_mulai`)"
                            >
                            </m-timepicker>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <label class="caption mb-2">Berakhir Istirahat</label>
                            <m-timepicker
                              v-model="jadwal.detail_jam_kerja.jam_istirahat_selesai"
                              :min="jadwal.detail_jam_kerja.jam_istirahat_mulai"
                              outlined
                              dense
                              :data-vv-name="`jam_istirahat_selesai`"
                              data-vv-as="Jam Berakhir Istirahat"
                              v-validate="'required'"
                              :error="errors.collect(`form-istirahat-${j}.jam_istirahat_selesai`)"
                            >
                            </m-timepicker>
                          </v-col>
                        </v-row>
                      </v-form>
                      <v-btn color="primary" small depressed @click="onBack(j)">
                        <v-icon left>mdi-chevron-left</v-icon> sebelumnya
                      </v-btn>
                      <v-btn class="mx-1" color="primary" small depressed @click="onNext(`form-istirahat-${j}`, j)">
                        Selanjutnya<v-icon right>mdi-chevron-right</v-icon>
                      </v-btn>
                    </div>
                  </v-stepper-content>
                  <v-stepper-content step="3">
                    <div class="primary--text">
                      <b class="body-1 font-weight-bold">Detail Awal Istirahat</b> (Lengkapi semua data berikut)
                    </div>
                    <v-form @submit.prevent :data-vv-scope="`form-istirahat-awal-${j}`" lazy-validation>
                      <v-row dense class="mt-2">
                        <v-col cols="12" sm="12" md="6">
                          <label class="caption mb-2">Batas Awal Istirahat Mulai</label>
                          <m-timepicker
                            v-model="jadwal.detail_jam_kerja.batas_awal_jam_istirahat_mulai"
                            :min="jadwal.detail_jam_kerja.jam_datang_akhir"
                            :max="jadwal.detail_jam_kerja.jam_istirahat_mulai"
                            outlined
                            dense
                            :data-vv-name="`batas_awal_jam_istirahat_mulai`"
                            data-vv-as="Batas Awal Istirahat Mulai"
                            v-validate="'required'"
                            :error="errors.collect(`form-istirahat-awal-${j}.batas_awal_jam_istirahat_mulai`)"
                          >
                          </m-timepicker>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label class="caption mb-2">Batas Akhir Istirahat Mulai</label>
                          <m-timepicker
                            v-model="jadwal.detail_jam_kerja.batas_akhir_jam_istirahat_mulai"
                            :min="jadwal.detail_jam_kerja.jam_istirahat_mulai"
                            :max="jadwal.detail_jam_kerja.jam_istirahat_selesai"
                            outlined
                            dense
                            :data-vv-name="`batas_akhir_jam_istirahat_mulai`"
                            data-vv-as="Batas Akhir Istirahat Mulai"
                            v-validate="'required'"
                            :error="errors.collect(`form-istirahat-awal-${j}.batas_akhir_jam_istirahat_mulai`)"
                          >
                          </m-timepicker>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <label class="caption mb-2">Toleransi Awal Istirahat Mulai</label>
                          <v-text-field
                            dense
                            single-line
                            outlined
                            label="Toleransi Awal Istirahat Mulai"
                            type="number"
                            v-model="jadwal.detail_jam_kerja.toleransi_istirahat_mulai"
                            :data-vv-name="`toleransi_istirahat_mulai`"
                            data-vv-as="toleransi awal istirahat mulai"
                            v-validate="'required'"
                            :error-messages="errors.collect(`form-istirahat-awal-${j}.toleransi_istirahat_mulai`)"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                    <v-btn class="mx-1" color="primary" small depressed @click="onBack(j)">
                      <v-icon left>mdi-chevron-left</v-icon> sebelumnya
                    </v-btn>
                    <v-btn color="primary" small depressed @click="onNext(`form-istirahat-awal-${j}`, j)">
                      Selanjutnya<v-icon right>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-stepper-content>
                  <v-stepper-content step="4">
                    <div class="primary--text">
                      <b class="body-1 font-weight-bold">Detail Akhir Istirahat</b> (Lengkapi semua data berikut)
                    </div>
                    <v-form @submit.prevent :data-vv-scope="`form-istirahat-akhir-${j}`" lazy-validation>
                      <v-row dense class="mt-2">
                        <v-col cols="12" sm="12" md="6">
                          <label class="caption mb-2">Batas Awal Istirahat Selesai</label>
                          <m-timepicker
                            v-model="jadwal.detail_jam_kerja.batas_awal_jam_istirahat_selesai"
                            :min="jadwal.detail_jam_kerja.jam_istirahat_mulai"
                            :max="jadwal.detail_jam_kerja.jam_istirahat_selesai"
                            outlined
                            dense
                            :data-vv-name="`batas_awal_jam_istirahat_selesai`"
                            data-vv-as="Batas Istirahat Awal Mulai"
                            v-validate="'required'"
                            :error="errors.collect(`form-istirahat-akhir-${j}.batas_awal_jam_istirahat_selesai`)"
                          >
                          </m-timepicker>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label class="caption mb-2">Batas Akhir Istirahat Selesai</label>
                          <m-timepicker
                            v-model="jadwal.detail_jam_kerja.batas_akhir_jam_istirahat_selesai"
                            :min="jadwal.detail_jam_kerja.jam_istirahat_selesai"
                            :max="jadwal.detail_jam_kerja.jam_pulang"
                            outlined
                            dense
                            :data-vv-name="`batas_akhir_jam_istirahat_selesai`"
                            data-vv-as="Batas Istirahat Akhir Selesai"
                            v-validate="'required'"
                            :error="errors.collect(`form-istirahat-akhir-${j}.batas_akhir_jam_istirahat_selesai`)"
                          >
                          </m-timepicker>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <label class="caption mb-2">Toleransi Akhir Istirahat Selesai</label>
                          <v-text-field
                            dense
                            single-line
                            outlined
                            label="Toleransi Akhir Istirahat Selesai"
                            type="number"
                            v-model="jadwal.detail_jam_kerja.toleransi_istirahat_selesai"
                            :data-vv-name="`toleransi_istirahat_selesai`"
                            data-vv-as="toleransi akhir istirahat selesai"
                            v-validate="'required'"
                            :error-messages="errors.collect(`form-istirahat-akhir-${j}.toleransi_istirahat_selesai`)"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                    <v-btn class="mx-1" color="primary" small depressed @click="onBack(j)">
                      <v-icon left>mdi-chevron-left</v-icon> sebelumnya
                    </v-btn>
                    <v-btn color="primary" small depressed @click="onNext(`form-istirahat-akhir-${j}`, j)">
                      Selanjutnya<v-icon right>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-stepper-content>
                  <v-stepper-content step="5">
                    <div class="primary--text">
                      <b class="body-1 font-weight-bold">Detail Jam Keluar Kerja</b> (Lengkapi semua data berikut)
                    </div>

                    <v-form @submit.prevent :data-vv-scope="`form-pulang-${j}`" lazy-validation>
                      <v-row dense class="mt-2">
                        <v-col cols="12" sm="12" md="12">
                          <template v-if="jamKerja.k_jenis_presensi !== 1">
                            <v-alert v-if="checkToleransiPulang(jadwal.detail_jam_kerja)" type="error" text>
                              Terdeteksi jam kerja yang masih ada irisan/bertabrakan. Cek kembali jam kerja, toleransi,
                              batas awal dan batas akhir
                            </v-alert>
                          </template>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label class="caption mb-2">Jam Pulang Kerja</label>
                          <m-timepicker
                            v-model="jadwal.detail_jam_kerja.jam_pulang"
                            :min="jadwal.detail_jam_kerja.jam_istirahat_selesai"
                            outlined
                            dense
                            :data-vv-name="`jam_pulang`"
                            data-vv-as="Jam Datang"
                            v-validate="'required'"
                            :error="errors.collect(`form-pulang-${j}.jam_pulang`)"
                          >
                          </m-timepicker>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label class="caption mb-2">Toleransi Keterlambatan Pulang(Menit)</label>
                          <v-text-field
                            dense
                            single-line
                            outlined
                            label="Toleransi Pulang (Menit)"
                            hint="Toleransi Pulang"
                            type="number"
                            v-model="jadwal.detail_jam_kerja.toleransi_pulang"
                            :data-vv-name="`toleransi_pulang`"
                            data-vv-as="toleransi pulang"
                            v-validate="'required'"
                            :error-messages="errors.collect(`form-pulang-${j}.toleransi_pulang`)"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label class="caption mb-2 t">Batas Awal (Boleh Absensi Pulang)</label>
                          <m-timepicker
                            v-model="jadwal.detail_jam_kerja.batas_jam_pulang_mulai"
                            :max="jadwal.detail_jam_kerja.jam_pulang"
                            :min="jadwal.detail_jam_kerja.jam_istirahat_selesai"
                            outlined
                            dense
                            :data-vv-name="`batas_pulang_mulai`"
                            data-vv-as="Batas Jam Pulang Mulai"
                            v-validate="'required'"
                            :error="errors.collect(`form-pulang-${j}.batas_pulang_mulai`)"
                          >
                          </m-timepicker>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label class="caption mb-2">Batas Akhir (Boleh Absensi Pulang)</label>
                          <m-timepicker
                            v-model="jadwal.detail_jam_kerja.batas_jam_pulang_akhir"
                            :min="jadwal.detail_jam_kerja.jam_pulang"
                            outlined
                            dense
                            :data-vv-name="`batas_pulang_selesai`"
                            data-vv-as="Batas Jam Pulang Selesai"
                            v-validate="'required'"
                            :error="errors.collect(`form-pulang-${j}.batas_pulang_selesai`)"
                          >
                          </m-timepicker>
                        </v-col>
                      </v-row>
                    </v-form>

                    <v-btn class="mx-1" color="primary" small depressed @click="onBack(j)">
                      <v-icon left>mdi-chevron-left</v-icon> sebelumnya
                    </v-btn>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="d-flex flex-row-reverse">
              <v-btn
                v-if="jamKerja.k_jenis_presensi"
                :disabled="!isSediaHari"
                color="warning"
                depressed
                @click="onAddJadwal"
              >
                <v-icon left>mdi-plus</v-icon> Detail Jadwal
              </v-btn>
            </div>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
import { JADWAL_REGULER, KONVERSI_JAM } from '../const'
export default {
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      konfigurasiDefault: {},
      roles: [],
      edit: false,
      duplicate: false,
      jumlahAtribut: 7,
      jamKerja: {},
      tipeJadwals: [],
      jadwalKerja: [],
      defjamKerja: {
        nama: null,
        keterangan: null,
        k_tipe_jadwal: null,
        tgl_berlaku: null,
        tgl_berakhir: null,
        k_jenis_presensi: 2,
        detail_jam_kerja: [],
      },
      presensis: [
        {
          key: 1,
          value: 'Presensi 1x Sehari',
        },
        {
          key: 2,
          value: 'Presensi 2x (Datang dan Pulang)',
        },
        {
          key: 3,
          value: 'Presensi 3x (Datang, Awal Istirahat, dan Pulang)',
        },
        {
          key: 4,
          value: 'Presensi 3x (Datang, Akhir Istirahat, dan Pulang)',
        },
        {
          key: 5,
          value: 'Presensi 4x (Datang, Awal Istirahat, Akhir Istirahat, dan Pulang)',
        },
      ],
      steppers: {
        1: 'Masuk',
        2: 'Istirahat',
        3: 'Awal Istirahat',
        4: 'Akhir Istirahat',
        5: 'Keluar',
      },
    }
  },

  computed: {
    masterStepper() {
      const mJenisAbsensi = {
        1: [1],
        2: [1, 2, 5],
        3: [1, 2, 3, 5],
        4: [1, 2, 4, 5],
        5: [1, 2, 3, 4, 5],
      }

      return this.jamKerja.k_jenis_presensi ? mJenisAbsensi[Number(this.jamKerja.k_jenis_presensi)] : []
    },

    isSediaHari() {
      let inUseHari = []
      const jadwalKerja = this.jadwalKerja || []
      jadwalKerja.forEach((item) => {
        const hari = item.hari || []
        hari.forEach((i) => {
          inUseHari.push(i)
        })
      })

      return inUseHari.length !== 7
    },
  },

  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.$validator.reset()
      this.getTipeJadwal()
      this.resetForm()
      obj ? Promise.resolve : this.getKonfigurasiDefault()
      this.defjamKerja.organisasi_id = this.organisasi_id || this.tenant_id
      this.jamKerja = obj
        ? { ...obj, ...(this.edit = true) }
        : { ...this.defjamKerja, detail_jam_kerja: [], ...(this.edit = false) }
      this.duplicate = false
      this.initForm(obj)
      return this.$refs.dlg.open()
    },
    resetForm() {
      this.jadwalKerja = []
    },
    initForm(value) {
      if (!value) return
      let jamKerja = (value && value.detail_jam_kerja) || []
      let grouping = {}
      let index = 0

      if (!value.k_jenis_presensi) {
        this.jamKerja.k_jenis_presensi = 2
      }

      jamKerja.forEach((item, idx) => {
        let checkDuplicate = []
        if (idx === 0 && jamKerja.length === 1) {
          checkDuplicate = jamKerja
        } else if (idx === 0) {
          checkDuplicate = jamKerja.filter((s) => s.hari !== item.hari) || []
        } else {
          if (grouping[index - 1]) {
            checkDuplicate = jamKerja.filter((s) => !grouping[index - 1].includes(s.hari)) || []
          } else {
            checkDuplicate = jamKerja.filter((s) => s.hari !== item.hari) || []
          }
        }

        let is_duplicate = []
        if (checkDuplicate.length) {
          checkDuplicate.forEach((check) => {
            let isEquals = []
            KONVERSI_JAM.forEach((konversi) => {
              isEquals.push(item[konversi] === check[konversi])
            })

            if (isEquals.filter((s) => s === false).length === 0) {
              is_duplicate.push(check.hari)
            }
          })
          let current = is_duplicate.filter((c, index) => is_duplicate.indexOf(c) === index) || []

          if (current.length) {
            if (current.filter((s) => s === item.hari).length === 0) {
              current.push(item.hari)
            }
            this.$set(grouping, index, current)
            index++
          }
        }
      })

      if (Object.keys(grouping).length) {
        Object.keys(grouping).forEach((index) => {
          if (!grouping[index]) return
          const init = grouping[index].sort().toString()
          Object.keys(grouping).forEach((i) => {
            if (i === index) return
            const result = grouping[i].sort().toString()
            if (result === init) {
              this.$delete(grouping, i)
            }
          })
        })
      }

      if (Object.keys(grouping).length) {
        Object.keys(grouping).forEach((index) => {
          const item = (grouping[index] && grouping[index][0]) || false
          if (item) {
            const find = jamKerja.find((s) => s.hari === item) || {}
            if (Object.keys(find).length) {
              let mapObj = {}
              let keys = [
                ...KONVERSI_JAM,
                'toleransi_datang',
                'toleransi_pulang',
                'toleransi_istirahat_mulai',
                'toleransi_istirahat_selesai',
              ]
              keys.forEach((key) => {
                this.$set(mapObj, key, !['', undefined, null].includes(find[key]) ? find[key] : '')
              })
              this.jadwalKerja.push({ stepper: 1, hari: grouping[index], detail_jam_kerja: mapObj, valid: {} })
            }
          }
        })
      } else {
        jamKerja.forEach((item) => {
          let mapObj = {}
          let keys = [
            ...KONVERSI_JAM,
            'toleransi_datang',
            'toleransi_pulang',
            'toleransi_istirahat_mulai',
            'toleransi_istirahat_selesai',
          ]

          keys.forEach((key) => {
            this.$set(mapObj, key, !['', undefined, null].includes(item[key]) ? item[key] : '')
          })

          this.jadwalKerja.push({ stepper: 1, hari: [item.hari], detail_jam_kerja: mapObj, valid: {} })
        })
      }
    },
    hari(obj) {
      const jadwalHari = obj.hari || []
      const temp = []
      const itemHari = ['SENIN', 'SELASA', 'RABU', 'KAMIS', 'JUMAT', 'SABTU', 'MINGGU']
      let inUseHari = []
      const jadwalKerja = this.jadwalKerja || []
      jadwalKerja.forEach((item) => {
        const hari = item.hari || []
        hari.forEach((i) => {
          inUseHari.push(i)
        })
      })

      jadwalHari.forEach((item) => {
        const findIndex = inUseHari.findIndex((s) => s === item)
        if (findIndex > -1) {
          inUseHari.splice(findIndex, 1)
        }
      })

      itemHari.forEach((item) => {
        temp.push({
          text: item,
          disabled: inUseHari.includes(item),
        })
      })

      return temp
    },
    getKonfigurasiDefault() {
      this.$store.dispatch('organisasi/cekSetting', this.organisasi_id || this.tenant_id).then((res) => {
        if (res.data.data) this.konfigurasiDefault = { ...res.data.data.konfigurasi }
      })
    },
    getTipeJadwal() {
      this.$store.dispatch('jamKerja/tipeJadwal').then((res) => {
        let data = res.data || []

        if (!this.jamKerja.konfigurasi_jadwal_id) {
          const index = data.findIndex((s) => Number(s.k_tipe_jadwal) === JADWAL_REGULER)
          if (index > -1) data.splice(index, 1)
        }

        const shift = data.findIndex((s) => s.k_tipe_jadwal === 3)
        if (shift > -1) data.splice(shift, 1)

        this.tipeJadwals = data.map((key) => {
          return {
            k_tipe_jadwal: key['k_tipe_jadwal'],
            keterangan: key['keterangan'],
            disabled: Number(key['k_tipe_jadwal']) === JADWAL_REGULER,
          }
        })
      })
    },
    onAddJadwal() {
      let detail = {}
      let keys = [
        ...KONVERSI_JAM,
        'toleransi_datang',
        'toleransi_pulang',
        'toleransi_istirahat_mulai',
        'toleransi_istirahat_selesai',
      ]
      keys.forEach((key) => {
        this.$set(detail, key, '')
      })

      this.jadwalKerja.push({ stepper: 1, hari: [], detail_jam_kerja: detail, valid: {} })
    },
    onDeleteJadwal(index) {
      this.jadwalKerja.splice(index, 1)
    },
    onChangeTipe(value) {
      this.jamKerja.detail_jam_kerja = []
      if (Number(value) === 100) {
        this.add()
      }
    },
    onChangePresensi(value) {
      const masterKey = {
        3: ['batas_awal_jam_istirahat_mulai', 'batas_akhir_jam_istirahat_mulai', 'toleransi_istirahat_mulai'],
        4: ['batas_awal_jam_istirahat_selesai', 'batas_akhir_jam_istirahat_selesai', 'toleransi_istirahat_selesai'],
      }

      if (value === 3) {
        this.onDeleteValue(masterKey[4])
      } else if (value === 4) {
        this.onDeleteValue(masterKey[3])
      } else {
        this.onDeleteValue(masterKey[3].concat(masterKey[4]))
      }
    },
    onDeleteValue(keys) {
      if (this.jadwalKerja.length) {
        this.jadwalKerja.forEach((item, index) => {
          keys.forEach((key) => {
            this.$set(this.jadwalKerja[index]['detail_jam_kerja'], key, null)
          })
        })
      }
    },
    onBack(index) {
      const step = this.jadwalKerja[index]['stepper']
      const current = this.masterStepper.findIndex((s) => s === Number(step))
      this.jadwalKerja[index]['stepper'] = Number(this.masterStepper[current - 1])
      if (this.jadwalKerja[index]['valid'][current]) this.$delete(this.jadwalKerja[index]['valid'], current)
    },
    async onNext(tipe, index) {
      const valid = await this.$validator.validateAll(tipe)
      if (!valid) return

      const step = this.jadwalKerja[index]['stepper']
      const current = this.masterStepper.findIndex((s) => s === Number(step))
      this.jadwalKerja[index]['stepper'] = Number(this.masterStepper[current + 1])
      if (this.jadwalKerja[index]['valid'][step]) this.$delete(this.jadwalKerja[index]['valid'], step)
      this.$set(this.jadwalKerja[index]['valid'], step, true)
    },
    checkValidate() {
      let valid = []
      const masterValidate = {
        1: 'form-datang',
        2: 'form-istirahat',
        3: 'form-istirahat-awal',
        4: 'form-istirahat-akhir',
        5: 'form-pulang',
      }

      const steppers = this.masterStepper

      for (let i = 0; i < this.jadwalKerja.length; i++) {
        steppers.forEach((index) => {
          this.$validator.validateAll(`${masterValidate[index]}-${i}`).then((res) => {
            this.$set(this.jadwalKerja[i]['valid'], index, res)
            if (!res) {
              valid.push(false)
            }
          })
        })
      }

      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(valid.filter((s) => s === false).length === 0)
        })
      })
    },
    checkToleransiPulang(obj) {
      if (
        !this.getDeepObj(obj, `jam_pulang`) ||
        !this.getDeepObj(obj, `toleransi_pulang`) ||
        !this.getDeepObj(obj, `batas_jam_pulang_mulai`)
      )
        return false

      const minutes = Number(this.getDeepObj(obj, `toleransi_pulang`) || 0)
      const start = new Date(`01-01-2024 ${this.getDeepObj(obj, `jam_pulang`)}`)
      const startEnd = new Date(start.getTime() - minutes * 60000)
      const end = new Date(`01-01-2024 ${this.getDeepObj(obj, `batas_jam_pulang_mulai`)}`)

      return startEnd < end
    },
    checkToleransi(obj) {
      if (
        !this.getDeepObj(obj, `jam_datang`) ||
        !this.getDeepObj(obj, `toleransi_datang`) ||
        !this.getDeepObj(obj, `batas_jam_datang_akhir`)
      )
        return false

      const minutes = Number(this.getDeepObj(obj, `toleransi_datang`) || 0)
      const start = new Date(`01-01-2024 ${this.getDeepObj(obj, `jam_datang`)}`)
      const startEnd = new Date(start.getTime() + minutes * 60000)
      const end = new Date(`01-01-2024 ${this.getDeepObj(obj, `batas_jam_datang_akhir`)}`)

      return startEnd > end
    },
    async save() {
      let status = await this.checkValidate()

      if (!status) return

      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          let detail_jam_kerja = []
          const jadwalKerja = this.jadwalKerja || []
          jadwalKerja.forEach((item) => {
            let detail = item.detail_jam_kerja
            let hari = item.hari || []
            KONVERSI_JAM.forEach((key) => {
              detail[key] = this.$getTimezone(detail[key], 3)
            })

            if (hari.length) {
              hari.forEach((h) => {
                detail_jam_kerja.push(Object.assign({}, detail, { hari: h }))
              })
            }
          })

          const jamKerja = Object.assign(
            {},
            this.jamKerja,
            {
              detail_jam_kerja: detail_jam_kerja,
            },
            { organisasi_id: this.organisasi_id || this.tenant_id || '' },
            { kode_organisasi: this.organisasi_id || '' }
          )

          return this.$store.dispatch('jamKerja/form', jamKerja)
        })
        .then(() => {
          this.$success('Aksi Berhasil dijalankan')
          this.$refs.dlg.resolve()
        })
        .catch(() => {
          const jadwalKerja = this.jadwalKerja || []
          jadwalKerja.forEach((item) => {
            let detail = item.detail_jam_kerja
            KONVERSI_JAM.forEach((key) => {
              detail[key] = this.$setTimezone(detail[key], 3)
            })
          })
        })
    },
  },
}
</script>
